import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {createTicketLinkMutation, CreateTicketLinkInput} from './__generated__/createTicketLinkMutation.graphql';

const mutation = graphql`
	mutation createTicketLinkMutation($input: CreateTicketLinkInput!) {
		createTicketLink(input: $input) {
			clientMutationId
			ticketLink {
				id
				ticketId
				linkType
				targetTicketId
				targetProjectId
				creator {
					id
					...ticketingPerson_person
				}
				createdAt
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: CreateTicketLinkInput,
	onCompleted?: (r: createTicketLinkMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<createTicketLinkMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'createTicketLinkMutation'};
